// Shared display formatters so money and dates look the same on every page.

const myrFormatter = new Intl.NumberFormat("en-MY", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

/** 1234.5 -> "RM 1,234.50". Null/invalid -> "RM 0.00". */
export function formatMYR(amount) {
  const n = Number(amount);
  return `RM ${myrFormatter.format(Number.isFinite(n) ? n : 0)}`;
}

function toDate(value) {
  if (!value) return null;
  const d = value instanceof Date ? value : new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
}

/** "12 Oct 2026". Empty/invalid -> fallback. */
export function formatDate(value, fallback = "—") {
  const d = toDate(value);
  return d ? d.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" }) : fallback;
}

/** "12 Oct 2026, 14:05". Empty/invalid -> fallback. */
export function formatDateTime(value, fallback = "—") {
  const d = toDate(value);
  return d
    ? d.toLocaleString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      })
    : fallback;
}
